import React from 'react';
import Image from 'next/image';

interface GearProduct {
  id: string;
  name: string;
  price: string;
  imageSrc: string;
  imageAlt: string;
  href: string;
  soldOut?: boolean;
  aspectRatio?: number;
}

const gearProducts: GearProduct[] = [
{
  id: '1',
  name: 'Authentic Bayside Coffee Co. Mug',
  price: '$12.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/image_fb89a0f3-8a18-4289-9a70-e7f37605246e_345x345.jpg?v=1605022628',
  imageAlt: 'Authentic Bayside Coffee Co. branded ceramic mug',
  href: '/checkout',
  soldOut: true,
  aspectRatio: 1.333
},
{
  id: '2',
  name: 'Bayside Coffee Co T Shirt (navy)',
  price: '$25.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/DAA3007A-FF07-4624-9D84-F4614722A77A_345x345.jpg?v=1607012317',
  imageAlt: 'Bayside Coffee Co navy blue t-shirt with logo',
  href: '/checkout',
  soldOut: true,
  aspectRatio: 1
},
{
  id: '3',
  name: 'Bayside Coffee Co. T Shirt',
  price: '$25.00',
  imageSrc: 'https://coffeebythebay.com/cdn/shop/products/ScreenShot2020-04-14at11.16.52AM_345x345.png?v=1586878110',
  imageAlt: 'Bayside Coffee Co. white t-shirt with logo design',
  href: '/checkout',
  soldOut: false,
  aspectRatio: 0.685
}];


function GearCard({ product }: {product: GearProduct;}) {
  const aspectRatio = product.aspectRatio ?? 1;
  return (
    <div className="gear-card">
      <a href={product.href} className="gear-card__link" aria-label={product.name}>
        <div
          className="gear-card__image-wrapper"
          style={{ paddingTop: `${1 / aspectRatio * 100}%` }}>
          
          <Image
            src={product.imageSrc}
            alt={product.imageAlt}
            fill
            className="gear-card__image"
            style={{ objectFit: 'contain' }}
            sizes="(max-width: 749px) 50vw, 33vw" />
          
        </div>
      </a>
      <div className="gear-card__title">{product.name}</div>
      <div className="gear-card__price">
        {product.soldOut ?
        <span className="sold-out">Sold out</span> :

        <span className="price-value">{product.price}</span>
        }
      </div>

      <style jsx>{`
        .gear-card {
          font-family: 'Work Sans', sans-serif;
        }
        .gear-card__link {
          display: block;
          text-decoration: none;
        }
        .gear-card__image-wrapper {
          position: relative;
          width: 100%;
          background: #f5f5f5;
          overflow: hidden;
        }
        .gear-card__title {
          margin-top: 10px;
          font-size: 17px;
          font-weight: 400;
          color: #3d4246;
          font-family: 'Work Sans', sans-serif;
        }
        .gear-card__price {
          margin-top: 4px;
          font-size: 15px;
          color: #3d4246;
        }
        .sold-out {
          color: #3d4246;
          font-size: 14px;
        }
        .price-value {
          font-weight: 400;
        }
      `}</style>
    </div>);

}

export default function GearSection() {
  return (
    <section id="gear" className="gear-section">
      <div className="page-width">
        <div className="section-header">
          <h2 className="section-title">Bayside Coffee Co. Authentic Gear</h2>
        </div>
        <ul className="gear-grid">
          {gearProducts.map((product) =>
          <li key={product.id} className="gear-grid__item">
              <GearCard product={product} />
            </li>
          )}
        </ul>
        <div className="view-all-wrap">
          <a href="#" className="view-all-btn">View all</a>
        </div>
      </div>

      <style jsx>{`
        .gear-section {
          padding: 50px 0;
          font-family: 'Work Sans', sans-serif;
        }
        .page-width {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 30px;
        }
        .section-header {
          text-align: center;
          margin-bottom: 30px;
        }
        .section-title {
          font-size: 20px;
          font-weight: 600;
          color: #3d4246;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin: 0;
          font-family: 'Work Sans', sans-serif;
        }
        .gear-grid {
          list-style: none;
          margin: 0;
          padding: 0;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px 20px;
        }
        .view-all-wrap {
          text-align: center;
          margin-top: 30px;
        }
        .view-all-btn {
          display: inline-block;
          padding: 10px 18px;
          border: 1px solid #557b97;
          color: #557b97;
          background: #fff;
          text-decoration: none;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
          font-weight: 500;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          transition: background 0.2s, color 0.2s;
        }
        .view-all-btn:hover {
          background: #557b97;
          color: #fff;
        }
        @media (max-width: 749px) {
          .gear-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
    </section>);

}